import React from 'react';
import { Box, Typography } from '@mui/material';
import { color, font } from './tokens';

/**
 * Compact page header. No hero banners, no "Welcome" text, no wasted height.
 *   <AppPageHeader title="Front Desk" subtitle="Manage bookings and arrivals."
 *                  actions={<ActionToolbar .../>} />
 */
export default function AppPageHeader({ title, subtitle, actions }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mb: 1.5,
      }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography component='h1' sx={{ ...font.pageTitle, color: color.text }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ ...font.helper, color: color.textMuted, mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>{actions}</Box>
      )}
    </Box>
  );
}